// @ts-nocheck

(function () {
  "use strict";

  // ============================================
  // CONFIGURATION
  // ============================================

  const CONFIG = {
    ENVIRONMENT: window.vmmvEnv,

    SCRIPT_URLS: {
      development: "https://vmmv-uat.luxottica.com/v/5.7/index.umd.js",
      uat: "https://vmmv-uat.luxottica.com/v/5.7/index.umd.js",
      prod: "https://vmmv.luxottica.com/v/5.7/index.umd.js",
    },

    VM_INIT: {
      key: "4c03a94c-2045-433f-8807-eba1f9e82da1",
      source: "VMMV_NUANCE",
      channel: "ecommerce",
      brand: "nuance",
    },

    SCRIPT_LOAD_TIMEOUT: 10000,
  };

  // ============================================
  // STATE
  // ============================================

  const state = {
    vmmvLoaded: false,
    vmmvInitialized: false,
    vmapp: null,
  };

  const rxState = {
    mode: "add-to-cart",
  };

  // ============================================
  // APP BRIDGE (RXC decoupling)
  // ============================================

  const AppBridge = {
    openRXC(payload) {
      document.dispatchEvent(new CustomEvent("rx:open", { detail: payload }));
    },
  };

  // ============================================
  // UTILS
  // ============================================

   const getScriptUrl = () => CONFIG.SCRIPT_URLS[CONFIG.ENVIRONMENT];

  const getGlassesEnv = () =>
    CONFIG.ENVIRONMENT === "prod" ? "PROD" : "TEST";

  // ============================================
  // VMMV CTA
  // ============================================

  function getVmmvButtons() {
    return document.querySelectorAll("[data-vto-cta]");
  }

  function hideVmmvButtons() {
    getVmmvButtons().forEach((btn) => {
      btn.hidden = true;
    });
  }

  function showVmmvButtons() {
    getVmmvButtons().forEach((btn) => {
      btn.hidden = false;
    });
  }

  // ============================================
  // TRANSITIONS
  // ============================================

  async function getTransitionLens() {
    const isProd = CONFIG.ENVIRONMENT === "prod";

    const url = isProd
      ? "https://vmmv.luxottica.com/assets/transitions/transitions-swatches.json"
      : "https://vmmv-uat.luxottica.com/assets/transitions/transitions-swatches.json";

    try {
      const res = await fetch(url);
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      const data = await res.json();
      if (!Array.isArray(data)) {
        console.warn("[VMMV] Invalid transitions format");
        return [];
      }
      const colorCodes = data.map((item) => item?.colorCode).filter(Boolean);
      return colorCodes;
    } catch (e) {
      console.error("[VMMV] transitions fetch error", e);
      return [];
    }
  }

  // ============================================
  // VMMV AVAILABILITY CHECK
  // ============================================

  async function checkVmmvAvailability() {
    try {
      if (!window.vmmv) {
        console.warn("[VMMV] VMMV library not available");
        return false;
      }
      const isBrowserSupported =
        await window.vmmv.isBrowserSupported();

      /* console.log(
        "[VMMV] Browser supported:",
        isBrowserSupported,
      ); */

      if (!isBrowserSupported) {
        console.warn("[VMMV] Browser not supported");
        return false;
      }

      const upcs = (window.vmmvProducts || [])
        .map((product) => product.upc)
        .filter(Boolean);

      /* console.log("[VMMV] UPCs:", upcs); */

      if (!upcs.length) {
        console.warn("[VMMV] No UPC found");
        return false;
      }

      const upcAvailabilityRaw =
        await window.vmmv.isUPCSupported(
          upcs,
          CONFIG.VM_INIT.key,
          getGlassesEnv(),
        );

      /* console.log(
        "[VMMV] UPC availability:",
        upcAvailabilityRaw,
      ); */

      const hasSupportedUPC = Object.values(
        upcAvailabilityRaw || {},
      ).some(
        (item) => item?.available === true,
      );

      /* console.log(
        "[VMMV] Has supported UPC:",
        hasSupportedUPC,
      ); */

      if (!hasSupportedUPC) {
        console.warn("[VMMV] No supported UPC");
        return false;
      }

      return true;
    } catch (error) {
      console.error(
        "[VMMV] Availability check error",
        error,
      );

      return false;
    }
  }

  function buildVMMVConfig(transitionColors) {
    const locale = window.vmmvProduct?.locale || "en-US";
    const showTransitions = window.vmmvProducts.some((p) => p.showTransitions);
    const localeCurrency = window.vmmvProduct?.currency || "USD";

    const transitionLens = transitionColors?.length
      ? { availableColors: transitionColors }
      : undefined;

    const products = window.vmmvProducts.map((color) => ({
      upc: color.upc,
      code: color.code,
      name: color.productTitle,
      colorCode: color.colorCode,
      thumbnailUrl: color.thumbnailUrl,
      brand: {
        name: color.brandName || "Nuance Audio",
        logoUrl: color.brandLogo || "",
      },
      lensColorLabel: color.lensColorLabel,
      frameColorLabel: color.frameColorLabel,
      styleName: color.styleName,
      size: color.size,
      frameSizeSelection:
        color.frameSizes?.map((s) => ({
          size: s.size,
          upc: s.upc,
          variantId: s.variantId,
        })) || [],
      isTransition: color.showTransitions,
      ...(transitionLens && { transitionLens }),
      modelcode: color.modelcode,
      /* rxAvailable: color.rxAvailable || false, */
      isSelected: true,
    }));
    const prices = window.vmmvProducts.map((color) => {
      const current = parseFloat(color.price || 0);
      const previous = parseFloat(color.offerPrice || 0);

      return {
        upc: color.upc,
        currency: localeCurrency,

        current: {
          text: String(current),
          value: current,
        },

        ...(previous > current && {
          previous: {
            text: String(previous),
            value: previous,
          },
        }),

        currencySpacer: "\u00A0",
      };
    });

    const config = {
      selector: ".vmmv-container",
      locale: locale,
      onAddToBag: handleAddToBag,
      onBeforeAddToCart,
      /* onToggleWishlist: async () => true, */
      onTermsAndConditionsClick: () => {},

      onClose: closeVMMV,
      onShare: handleShare,

      /* onAddPrescriptionLenses: handleAddPrescriptionLenses, */
      products,
      prices,
      store: {
        id: "",
        storeId: window.vmmvProduct?.storeId,
        type: "nuance",
        name: window.vmmvProduct?.storeName || "Nuance Audio",
        standAlone: false,
        region: window.vmmvProduct?.region,
        countryId: window.vmmvProduct?.countryId,
      },
      style: "nuance",
      vmInit: {
        key: CONFIG.VM_INIT.key,
        source: CONFIG.VM_INIT.source,
        channel: CONFIG.VM_INIT.channel,
        brand: CONFIG.VM_INIT.brand,
        glassesEnv: getGlassesEnv()
      },
      fromStore: true,
      transitionFeature: {
        enabled: showTransitions,
      },
      isTryOnEnabled: true,
      isPictureModeEnabled: true,
      isUploadPictureEnabled: true,
      isVideoModeEnabled: true,
      isQrCodeEnabled: false,
      isTakeScreenshotEnabled: true,
      isTakePictureEnabled: true,
      priceLineOrder: ["fullPrice", "newPrice"],
      currencySide: "LEFT",
      isMonobrand: true,
      useCartIcon: false,
      addToCartText:
        rxState.mode === "select-lenses" ? "Select lenses" : "Add to bag",
    };
    /* console.log("[VMMV] config: ", config); */
    return config;
  }

  async function handleAddToBag(product, frameSize) {
    /* console.log("[VMMV] Add to bag:", {
      product,
      frameSize,
      mode: rxState.mode,
    }); */

    const selectedProduct = product;

    const selectedSize = selectedProduct?.frameSizeSelection?.find(
      (size) => String(size.size) === String(frameSize)
    );

    if (!selectedSize) {
      console.warn("[VMMV] Selected size not found", {
        frameSize,
        frameSizeSelection: selectedProduct?.frameSizeSelection,
      });

      return;
    }

    const variantId = selectedSize.variantId;

    if (!variantId) {
      console.warn("[VMMV] Missing variantId", {
        selectedProduct,
        selectedSize,
      });

      return;
    }

    /* console.log("[VMMV] Selected Shopify variant:", {
      variantId,
      frameSize,
      product: selectedProduct,
    }); */

    if (rxState.mode === "select-lenses") {
      await closeVMMV();

      AppBridge.openRXC({
        variantId,
        product: selectedProduct,
        frameSize,
      });

      return;
    }

    try {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      document.dispatchEvent(
        new CustomEvent("cart:refresh")
      );

      await closeVMMV();

      window.location.href = "/cart";
    } catch (err) {
      console.error("[VMMV] add to cart error", err);
    }
  }

  async function closeVMMV() {
    try {
      await state.vmapp?.unmount?.();
    } catch (e) {
      console.warn("[VMMV] unmount error", e);
    }

    state.vmapp = null;
    state.vmmvInitialized = false;

    document.getElementById("vmmv-root")?.style.setProperty("display", "none");
  }

  function handleShare(image, product) {
    /* console.log("[VMMV] Share", product); */
  }

  function onBeforeAddToCart() {
    /* console.log("[VMMV] onBeforeAddToCart"); */
    const result = {
      product: true,
      frameSize: true,
      availableSizes: [],
    };

    /* console.log("[VMMV] return value:", result); */

    return Promise.resolve(result);
  }

  // ============================================
  // SCRIPT LOADER
  // ============================================

  async function loadScript() {
    return new Promise(
      (resolve, reject) => {
        if (window.vmmv) {
          state.vmmvLoaded = true;
          resolve();
          return;
        }

        const scriptUrl =
          getScriptUrl();

        if (!scriptUrl) {
          reject(
            new Error(
              `[VMMV] Unknown environment: ${CONFIG.ENVIRONMENT}`,
            ),
          );

          return;
        }

        /* console.log(
          "[VMMV] Loading script:",
          scriptUrl,
        ); */

        const s =
          document.createElement(
            "script",
          );

        s.src = scriptUrl;

        s.async = true;

        const timeout =
          setTimeout(() => {
            reject(
              new Error(
                "VMMV timeout",
              ),
            );
          }, CONFIG.SCRIPT_LOAD_TIMEOUT);

        s.onload = () => {
          clearTimeout(timeout);

          state.vmmvLoaded = true;

          /* console.log(
            "[VMMV] Script loaded",
          ); */

          resolve();
        };

        s.onerror = (error) => {
          clearTimeout(timeout);

          console.error(
            "[VMMV] Script load error",
            error,
          );

          reject(error);
        };

        document.head.appendChild(
          s,
        );
      },
    );
  }

  // ============================================
  // INIT VMMV
  // ============================================

  async function initVMMV() {
    try {
      if (state.vmmvInitialized) {
        return;
      }

      if (!window.vmmv) {
        await loadScript();
      }

      const vmapp =
        new window.vmmv.VMWidgetApp();
      state.vmapp = vmapp;

      const transitionColors = await getTransitionLens();
      const config = buildVMMVConfig(transitionColors);

      document
        .getElementById("vmmv-root")
        ?.style.setProperty("display", "flex");

      await vmapp.setConfig(config);
      await vmapp.init();

      state.vmmvInitialized = true;
      /* console.log("[VMMV] ready"); */
    } catch (e) {
       console.error("[VMMV] init error", e);
        await closeVMMV();
    }
  }

  // ============================================
  // BACKEND DUMP API
  // ============================================

  async function fetchVmmvDump() {
    const isProd = CONFIG.ENVIRONMENT === "prod";

    const url = isProd
      ? "https://gw-api-vtocatalogue.luxdeepblue.com/api/availabilitydump"
      : "https://test-api-vtocatalogue.luxdeepblue.com/api/availabilitydump";

    const token = isProd ? window.VMMV_PROD_TOKEN : window.VMMV_QA_TOKEN;

    try {
      const res = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          Authorization: `bearer ${token}`,
        },
      });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();

      const map = {};

      if (!Array.isArray(data?.assets)) {
        console.warn("[VMMV] Invalid dump response");
        return {};
      }

      data.assets.forEach((asset) => {
        const upc = asset?.upc?.id;

        if (upc) {
          map[upc] = asset.available === true;
        }
      });

      /* console.log("[VMMV] Dump loaded:", map); */

      return map;
    } catch (error) {
      console.error("[VMMV] Dump API error:", error);
      return {};
    }
  }

  // ============================================
  // RXC LISTENER
  // ============================================

  function setupRXCListener() {
    document.addEventListener("select-lenses", async () => {
      /* console.log("[RXC] select-lenses"); */

      rxState.mode = "select-lenses";
    });

    document.addEventListener("rxc-unavailable", async () => {
      /* console.log("[RXC] rxc-unavailable"); */

      rxState.mode = "add-to-cart";
    });

    document.addEventListener("rx:open", (e) => {
      /* console.log("[APP] RXC open request", e.detail); */

      document.dispatchEvent(
        new CustomEvent("prescription-lenses-click", {
          detail: e.detail,
        }),
      );
    });
  }

  // ============================================
  // BUTTON CLICK HANDLER
  // ============================================

  function setupVmmvButtons() {
    const buttons =
      getVmmvButtons();

    buttons.forEach((btn) => {
      if (
        btn.dataset.vmmvListenerAttached ===
        "true"
      ) {
        return;
      }

      btn.dataset.vmmvListenerAttached =
        "true";

      btn.addEventListener(
        "click",
        () => {
          if (
            !state.vmmvInitialized
          ) {
            initVMMV();
          }
        },
      );
    });
  }

  // ============================================
  // BOOT
  // ============================================

  async function init() {
    setupRXCListener();

    const buttons = getVmmvButtons();

    if (!buttons.length) {
      /* console.log("[VMMV] No Try-On CTA found"); */
      return;
    }

    hideVmmvButtons();

    try {
      await loadScript();

      await window.vmmv?.warmUp?.();

      const isAvailable = await checkVmmvAvailability();

      if (!isAvailable) {
        console.warn("[VMMV] Try-On not available");
        hideVmmvButtons();
        return;
      }

      /* console.log("[VMMV] Try-On available"); */

      showVmmvButtons();

      setupVmmvButtons();

    } catch (error) {
      console.error(
        "[VMMV] CTA availability check failed",
        error
      );

      hideVmmvButtons();
    }
  }

  // ============================================
  // START
  // ============================================

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init,
    );
  } else {
    init();
  }
})();
